import React from 'react';
import { X, Scale, ArrowRight } from 'lucide-react';
import { useCompare } from '../../context/ProductContext';
import { getProductThumb } from '../../data/productImages';

export function CompareBar() {
  const { compareItems, removeFromCompare, clearCompare, setCompareOpen } = useCompare();

  if (compareItems.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[75] border-t bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.1)] no-print" data-testid="compare-bar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-4">
        {/* Icon + label */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <Scale className="w-4 h-4 text-indigo-600" />
          <span className="text-sm font-semibold">{compareItems.length}/3</span>
        </div>

        {/* Thumbnails */}
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {compareItems.map(p => (
            <div key={p.sku} className="relative flex-shrink-0 group">
              <img
                src={getProductThumb(p.sku, p.category).replace('w=80', 'w=120')}
                alt={p.sku}
                className="w-11 h-11 rounded-lg border bg-white object-contain p-0.5"
              />
              <button
                onClick={() => removeFromCompare(p.sku)}
                className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-red-500 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <X className="w-2.5 h-2.5" />
              </button>
              <div className="absolute -bottom-0.5 left-0 right-0 text-center">
                <span className="text-[8px] font-mono bg-white/90 px-1 rounded">{p.sku}</span>
              </div>
            </div>
          ))}
          {/* Empty slots */}
          {Array.from({ length: 3 - compareItems.length }).map((_, i) => (
            <div key={`empty-${i}`} className="w-11 h-11 rounded-lg border-2 border-dashed border-border flex-shrink-0 flex items-center justify-center">
              <span className="text-[10px] text-muted-foreground">+</span>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={clearCompare}
            className="h-9 px-3 rounded-lg border text-xs font-medium text-muted-foreground hover:text-red-500 hover:border-red-200 transition-colors"
          >
            Annulla
          </button>
          <button
            onClick={() => setCompareOpen(true)}
            disabled={compareItems.length < 2}
            className="h-9 px-5 rounded-lg bg-indigo-600 text-white text-sm font-medium flex items-center gap-1.5 hover:bg-indigo-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            data-testid="compare-open-button"
          >
            Confronta {compareItems.length} prodotti <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
